import React from 'react';
import { Icon, Picture } from 'components';
import { formatDateString, formatPhoneTable } from 'utils/formatString';

export const TABLE_TYPES = {
  EXPENSES: 1,
  PAYMENTS: 2,
};

export const TABLE_CONFIGS = {
  [TABLE_TYPES.EXPENSES]: {
    desktopColumns: [
      {
        title: 'Время',
        modify: 'img',
        colSize: 'md',
        textColor: 'grey50',
        data: (col) => (
          <>
            <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />
            <span>{formatDateString(col.dateTime, 'HH:mm')}</span>
          </>
        ),
      },
      {
        title: 'Услуга',
        colSize: 'lg',
        data: (col) => col.operation,
      },
      {
        title: 'Номер',
        colSize: 'md',
        data: formatPhoneTable,
      },
      {
        title: 'Объем услуг',
        colSize: 'md',
        data: (col) => col.formattedTraffic,
        formatter: (val) => (val === '0' ? '—' : val),
      },
      {
        title: 'Баланс',
        textColor: 'grey50',
        colSize: 'lg',
        data: (col) => col.balances[0].balanceText,
      },
      {
        title: 'Списание',
        colSize: 'md',
        data: (col) => `${col?.balances[0].valueChange} ₽`,
      },
      {
        title: 'Остаток',
        colSize: 'md',
        data: (col) => `${col?.balances[0].value} ₽`,
      },
    ],
    mobileColumns: {
      icon: {
        classes: ['table-body__logo'],
        data: (col) => (
          <Picture defaultImage={`https://static.beeline.ru/upload/images/detalization/${col.filterId}.svg`} />
        ),
      },
      title: {
        data: (col) => col.operation,
      },
      price: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => `${col?.balances[0].valueChange} ₽`,
      },
      description: {
        data: formatPhoneTable,
      },
      time: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => formatDateString(col.dateTime, 'HH:mm'),
      },
    },
    dateGetter: (col) => new Date(`${col.dateTime}`),
    columnFormatter: (x) => ((x === '' || x === undefined) ? '—' : x),
  },
  [TABLE_TYPES.PAYMENTS]: {
    desktopColumns: [
      {
        title: 'Дата платежа',
        textColor: 'grey50',
        data: (col) => formatDateString(col.date, 'DD.MM.YYYY'),
      },
      {
        title: 'Канал',
        textColor: 'grey50',
        colSize: 'sm',
        data: (col) => col.channel,
      },
      {
        title: 'Статус',
        textColor: 'grey50',
        colSize: 'sm',
        data: (col) => col.statusText,
      },
      {
        title: 'Сумма',
        textColor: 'grey50',
        colSize: 'sm',
        data: (col) => col.formattedValue,
      },
    ],
    mobileColumns: {
      icon: {
        classes: ['table-body__logo'],
        data: () => (
          <Icon name="download" />
        ),
      },
      title: {
        data: (col) => col.channel,
      },
      price: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => `+${col.formattedValue}`,
      },
      description: {
        data: (col) => col.statusText,
      },
      time: {
        classes: ['table--text-right'],
        color: 'gray50',
        data: (col) => formatDateString(col.date, 'DD.MM.YYYY'),
      },
    },
    dateGetter: (col) => new Date(`${col.date}`),
    columnFormatter: (x) => ((x === '' || x === undefined) ? '—' : x),
    showDate: false,
  },
};
